// extracted by mini-css-extract-plugin
export default {"root":"ImageViewer_root__8dlAO","fadein":"ImageViewer_fadein__EK4xj","slide":"ImageViewer_slide__NOmU6","close":"ImageViewer_close__20x8E","movein":"ImageViewer_movein__SV5XL"};